/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Empty_DefaultInputs */

const cs_empty_default = /** @type {(inputs: Empty_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná data.`)
};

const en_empty_default = /** @type {(inputs: Empty_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data.`)
};

/**
* | output |
* | --- |
* | "No data." |
*
* @param {Empty_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const empty_default = /** @type {((inputs?: Empty_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_empty_default(inputs)
	return cs_empty_default(inputs)
});